export class Consts {
	public static DEBUG_API_BASE_URL: string = "http://localhost:8081";
	public static GRAPH_API_BASE_URL: string = "https://graph.microsoft.com/v1.0/";
	public static CHANNEL_NAME_GENERAL: string = 'General';
	public static BUCKET_NAME_TODO: string = 'To Do';
	public static BUCKET_NAME_TODO2: string = 'To do';
	public static GRAPH_API_UPLOAD_MAX_FILESIZE: number = 4194304; // 4*1024*1024;
	public static GRAPH_API_FRAGMENT_SIZE: number = 10485760; // 10*1024*1024;
	// local storage
	public static LOCAL_STORAGE_KEY_MSAL_ACCESSTOKENINFO: string = 'msal.accessTokenInfo';
	public static LOCAL_STORAGE_KEY_USER_ID: string = 'user.id';
	public static LOCAL_STORAGE_KEY_USER_DISPLAYNAME: string = 'user.displayName';
	public static LOCAL_STORAGE_KEY_USER_GROUPID: string = 'user.groupId';
	public static LOCAL_STORAGE_KEY_USER_SECURITY_GROUPID: string = 'user.securityGroupId';

	public static PATH_USER: string = '/';
	public static PATH_USER_CHANNELS: string = '/channels';
	public static PATH_ADMIN: string = '/admin';
	public static PATH_ADMIN_CHANNELS: string = '/admin/channels';

	public static EMPTY_STRING: string = '';
}
